import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1500Model } from "../kymw1500.model";
import { MarkFile } from "../vo/mark-file.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
type GetMarkFileResponse = {
  MarkCode: string,
  MarkCodeBranch: string,
  MarkName: string,
  MarkFileName: string,
  MarkFileUrl: string,
  MarkGroupCode: string,
  SupplyPromoteMarkDiv: string,
  StartOrderCode: string,
  StartDelivCatalogId: string,
  EndOrderCode: string,
  EndDelivCatalogId: string,
  DelivEndDate: string,
  RegistDate: string,
  FileRegistDate: string
}[];

/**
 * マークファイル情報検索サービス
 * @export GetMarkFileService
 * @class GetMarkFileService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMarkFileService extends PlessJsonResponderSub<GetMarkFileResponse> {
  model: KYMW1500Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMarkFileService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        MarkName: this.model.markName,
        MarkFileName: this.model.markFileName,
        MarkGroupCode: this.model.markGroupCode,
        SupplyPromoteMarkDiv: this.model.supplyPromoteMarkDiv,
        RegistMarkDateFrom: this.model.registMarkDateFrom,
        RegistMarkDateTo: this.model.registMarkDateTo,
        FileRegistDateFrom: this.model.fileRegistDateFrom,
        FileRegistDateTo: this.model.fileRegistDateTo,
        FileNonRegistOnly: this.model.fileNonRegistOnly,
        UnabledOnly: this.model.unabledOnly,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMarkFileService
   */
  execute(model: KYMW1500Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getMarkFile', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMarkFileService
   */
  success(data: GetMarkFileResponse) {
    this.model.markFileList = data.map(_ => new MarkFile(
      _.MarkCode,
      _.MarkCodeBranch,
      _.MarkName,
      _.MarkFileName,
      _.MarkFileUrl,
      _.MarkGroupCode,
      _.SupplyPromoteMarkDiv,
      _.StartOrderCode,
      _.StartDelivCatalogId,
      _.EndOrderCode,
      _.EndDelivCatalogId,
      _.DelivEndDate,
      _.RegistDate,
      _.FileRegistDate,
    ))
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
